import React, { useState } from 'react';
import './ShopPage.css';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const products = [
    {
      id: 1,
      name: "Moiz LMF 48 Lotion",
      category: "lotion",
      price: "Rs 263",
      image: process.env.PUBLIC_URL + "/images/Moizlotion.jpg",
      description: "48 Hour Long-Lasting Moisturizer | Non-Comedogenic | Paraben & Cruelty-Free",
      amazonLink: "https://amzn.to/42l2SgW",
      rating: 4.5,
      reviews: 673
    },
    {
      id: 2,
      name: "Moiz Cleansing Lotion",
      category: "cleanser",
      price: "Rs 304",
      image: process.env.PUBLIC_URL + "/images/Moiz.jpg",
      description: "Sulfate-free cream cleanser | For Sensitive Skin. Soap | Paraben & Sulphate Free",
      amazonLink: "https://amzn.to/4pS4icK",
      rating: 4.5,
      reviews: 1471
    },
    {
      id: 3,
      name: "DERMATOUCH Salicylic Acid 2% Face Wash",
      category: "facewash",
      price: "Rs 141",
      image: process.env.PUBLIC_URL + "/images/Dermatouch.jpg",
      description: "For Acne & Oil Control | Suitable to All Skin Types | For both Men & Women",
      amazonLink: "https://amzn.to/4mGS2cB",
      rating: 4.2,
      reviews: 2226
    },
    {
      id: 4,
      name: "Episoft OC Cleansing Gel",
      category: "cleanser",
      price: "Rs 468",
      image: process.env.PUBLIC_URL + "/images/Episoftcleanser.jpg",
      description: "For Oily, Combination & Normal Skin | Daily Facewash | Cleanser for Acne Prone Skin",
      amazonLink: "https://amzn.to/4mL3Ryj",
      rating: 4.4,
      reviews: 429
    },
    {
      id: 5,
      name: "Molecular Company 5% Niacinamide Moisturizing Gel Sunscreen ,Spf 50+ Pa++++",
      category: "sunscreen",
      price: "Rs 281",
      image: process.env.PUBLIC_URL + "/images/molecularsunscreen.jpg",
      description: "For Oily, Dry, Sensitive, Combination, Dull, Acne Prone Skin | 8 Hr Protection",
      amazonLink: "https://amzn.to/46PnHT2",
      rating: 4.4,
      reviews: 193
    },
    {
      id: 6,
      name: "Dr. Sheth's Ceramide & Vitamin C Sunscreen SPF 50+ PA++++",
      category: "sunscreen",
      price: "Rs 346",
      image: process.env.PUBLIC_URL + "/images/DrShethsunscreen.jpg",
      description: "For UVA/UVB & Blue Light & IR Protection | No white cast | For All Skin Types ",
      amazonLink: "https://amzn.to/4nxMzWM",
      rating: 4.2,
      reviews: 11852
    },
    {
      id: 7,
      name: "NuBase Aqua Soft Facial Day & Night Cream",
      category: "moisturizer",
      price: "Rs 485",
      image: process.env.PUBLIC_URL + "/images/NuBase.jpg",
      description: "Facial Day & Night Cream with SPF 30",
      amazonLink: "https://amzn.to/3IOLieG",
      rating: 5,
      reviews: 3
    },
    {
      id: 8,
      name: "Minimalist 5% Aquaporin Booster Facewash",
      category: "facewash",
      price: "Rs 284",
      image: process.env.PUBLIC_URL + "/images/Minimalistfacewash.jpg",
      description: "Hydrating Face Wash For Dry Skin with Hyaluronic Acid | Sulphate Free",
      amazonLink: "https://amzn.in/d/6yR0QTH",
      rating: 4.2,
      reviews: 2156
    },
    {
      id: 9,
      name: "Episoft Ac Lightweight Moisturizer With Microencapsulated Sunscreen",
      category: "sunscreen",
      price: "Rs 485",
      image: process.env.PUBLIC_URL + "/images/Episoftsunscreen.jpg",
      description: "Acne Safe | All Skin Types | Paraben & Fragrance Free",
      amazonLink: "https://amzn.in/d/ahljXZf",
      rating: 4.3,
      reviews: 4425
    }
  ];

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'cleanser', name: 'Cleansers' },
    { id: 'facewash', name: 'Facewash' },
    { id: 'moisturizer', name: 'Moisturizers' },
    { id: 'lotion', name: 'Lotions' },
    { id: 'sunscreen', name: 'Sunscreen' }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star filled">★</span>);
    }
    if (hasHalfStar) {
      stars.push(<span key="half" className="star half">★</span>);
    }
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="star empty">★</span>);
    }
    return stars;
  };

  return (
    <div className="products-section">
      <div className="container">
        <div className="products-header">
         <nav className="product-nav">
          <a href="/" className="product-logo">Clear&Bare</a>
          <ul className="product-nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/legal">Legal</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
         </nav>     
          <h1>Skincare Essentials</h1>
          <p className="subtitle">Curated products for healthy, radiant skin</p>
        </div>

        <div className="category-filter">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="products-grid">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
                <div className="product-overlay">
                  <a 
                    href={product.amazonLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="quick-view-btn"
                  >
                    View on Amazon
                  </a>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <div className="product-rating">
                  <div className="stars">
                    {renderStars(product.rating)}
                  </div>
                  <span className="review-count">({product.reviews})</span>
                </div>
                <p className="product-description">{product.description}</p>
                <div className="product-footer">
                  <span className="product-price">{product.price}</span>
                  <a 
                    href={product.amazonLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="buy-btn"
                  >
                    Shop Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="affiliate-disclaimer">
          <p>Prices and availability are subject to change.</p>
        </div>
      </div>
    </div>
  );
};

export default Products;